import styled from 'styled-components';

// Container for the action buttons
export const ActionContainer = styled.div`
  display: flex;
  background-color: white;
  border-bottom: 1px solid #f3f4f6;
`;

// Divider between buttons
export const Divider = styled.div`
  width: 1px;
  background-color: #e5e7eb;
`;

// Base button styles

export const ChatCaseActions = styled.div`
flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
	gap: 8px;
  border: none;
  background-color: ${( props ) => {
		if ( props.disabled ) {
			return props.$isEnded ? '#f5f5f5' : 'transparent';
		}
		return props.$active ? ( props.$danger ? '#FEF2F2' : '#F0FDF4' ) : 'transparent';
	}};
  color: ${( props ) => {
		if ( props.disabled ) {
			return props.$isEnded ? '#9ca3af' : props.$danger ? '#ef4444' : '#059669';
		}
		return props.$danger ? '#DC2626' : props.$active ? '#047857' : '#059669';
	}};
  font-size: 0.75rem;
  font-weight: 400;
  cursor: ${( props ) => ( props.disabled ? 'not-allowed' : 'pointer' )};
  opacity: ${( props ) => ( props.disabled ? ( props.$isEnded ? 1 : 0.6 ) : 1 )};
  transition: all 0.2s;
  border-radius: 0;

  &:hover:not(:disabled) {
    background-color: ${( props ) => ( props.$danger ? '#FEF2F2' : '#F0FDF4' )};
  }

  &:focus {
    outline: none;
  }

  ${props => props.$isEnded && `
    pointer-events: none;
  `}
`;

export const ActionButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border: none;
  background-color: ${( props ) => {
		if ( props.disabled ) {
			return props.$isEnded ? '#f5f5f5' : 'transparent';
		}
		return props.$active ? ( props.$danger ? '#FEF2F2' : '#F0FDF4' ) : 'transparent';
	}};
  color: ${( props ) => {
		if ( props.disabled ) {
			return props.$isEnded ? '#9ca3af' : props.$danger ? '#ef4444' : '#059669';
		}
		return props.$danger ? '#DC2626' : props.$active ? '#047857' : '#059669';
	}};
  font-size: 0.75rem;
  font-weight: 400;
  cursor: ${( props ) => ( props.disabled ? 'not-allowed' : 'pointer' )};
  opacity: ${( props ) => ( props.disabled ? ( props.$isEnded ? 1 : 0.6 ) : 1 )};
  transition: all 0.2s;
  border-radius: 0;

  &:hover:not(:disabled) {
    background-color: ${( props ) => ( props.$danger ? '#FEF2F2' : '#F0FDF4' )};
  }

  &:focus {
    outline: none;
  }

  ${props => props.$isEnded && `
    pointer-events: none;
  `}
`;

// Icon wrapper for consistent spacing
export const IconWrapper = styled.span`
  display: inline-flex;
  margin-right: 0.375rem;
`;
